import {Component, OnInit} from '@angular/core';
import {NgbDateStruct, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import {Observable, Subject} from 'rxjs';
import {MerlinxCarEntry} from '../../../shared/interfaces/merlinx-car-entry';
import {debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';
import {MerlinxService} from '../../../shared/services/merlinx.service';
import {Params, Router} from '@angular/router';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-engine-merlinx-carrental',
  templateUrl: './engine-merlinx-carrental.component.html',
  styleUrls: ['./engine-merlinx-carrental.component.scss']
})
export class EngineMerlinxCarrentalComponent implements OnInit {

  constructor(private mxs: MerlinxService,
              private router: Router) { }

  isLoading: boolean;
  locations$: Observable<MerlinxCarEntry[]>;
  locationQuery$ = new Subject<string>();
  ages: number[] = [18, 19, 20, 21, 22, 23, 24, 25];
  times: NgbTimeStruct[];
  selectedAge: number;
  selectedLocation: MerlinxCarEntry;
  selectedCheckinDate: NgbDateStruct;
  selectedCheckinTime: NgbTimeStruct;
  selectedCheckoutDate: NgbDateStruct;
  selectedCheckoutTime: NgbTimeStruct;

  ngOnInit(): void {
    this.populateTimes();
    this.selectedAge = 25;
    this.locations$ = this.locationQuery$.pipe(
      distinctUntilChanged(),
      tap(() => this.isLoading = true),
      debounceTime(200),
      switchMap(e => this.mxs.carQuery(e)),
      tap(() => this.isLoading = false)
    );
  }

  populateTimes(): void {
    const ret: NgbTimeStruct[] = [];
    const hours = 24;
    const minutes = [0, 15, 30, 45];
    for (let i = 0; i < hours; i++) {
      minutes.forEach(e => {
        const time = {hour: i, minute: e, second: 0};
        if (time.hour === 10 && time.minute === 0) {
          this.selectedCheckinTime = time;
          this.selectedCheckoutTime = time;
        }
        ret.push(time);
      });
    }
    this.times = ret;
  }

  getTimeItemName(input: NgbTimeStruct): string {
    let ret = '';
    if (input.hour < 10) {
      ret += '0';
    }
    ret += input.hour;
    ret += ':';
    if (input.minute < 10) {
      ret += '0';
    }
    ret += input.minute;
    return ret;
  }

  getCarItemName(input: MerlinxCarEntry): string {
    return `${input.cityName}`;
  }

  getAgeString(input: number): string {
    if (input >= 25) {
      return '25 anni e oltre';
    }
    return `${input} anni`;
  }

  canSearch(): boolean {
    const conditions = [];
    conditions.push(!!this.selectedLocation);
    conditions.push(!!this.selectedCheckinDate);
    conditions.push(!!this.selectedCheckoutDate);
    return !conditions.includes(false);
  }

  convertDateFromNgb(input: NgbDateStruct): string {
    return dayjs(`${input.day}-${input.month}-${input.year}`, 'D-M-YYYY').format('DD.MM.YYYY');
  }

  convertTimeFromNgb(input: NgbTimeStruct): string {
    return this.getTimeItemName(input).replace(':', '');
  }

  doSearch(): void {
    const codePlace = this.selectedLocation.code;
    const depDate = this.convertDateFromNgb(this.selectedCheckinDate);
    const retDate = this.convertDateFromNgb(this.selectedCheckoutDate);
    const departureTime = this.convertTimeFromNgb(this.selectedCheckinTime);
    const returnTime = this.convertTimeFromNgb(this.selectedCheckoutTime);
    const agePax = this.selectedAge;

    const queryParams: Params = {};

    const url = 'm/autonoleggio';
    queryParams.transport = 'multi';
    queryParams.depc = codePlace;
    queryParams.depdc = depDate;
    queryParams.dtc = departureTime;
    queryParams.retdc = retDate;
    queryParams.rtc = returnTime;
    queryParams.da = agePax;

    this.router.navigate([url], {queryParams});
  }

}
